import gql from 'graphql-tag'

export const QUERY_LIST_INDUSTRIES = gql`
  query ListIndustries($pagination: PaginationParams!) {
    listIndustries(pagination: $pagination) {
      count
      data {
        _id
        accountId
        origin
        source
        name
        is_test
        color
      }
    }
  }
`
